import React from 'react';
import PropTypes from 'prop-types';
import ShowComponent from '../hocs/ShowComponent';

@ShowComponent
class InfoAlertComponent extends React.Component {
  render() {
    const {
      text,
    } = this.props;

    return (
      <div className="alert-info columns">
        {text}
      </div>
    );
  }
}

InfoAlertComponent.propTypes = {
  text: PropTypes.node,
};

InfoAlertComponent.defaultProps = {
  text: '',
};

export default InfoAlertComponent;
